import axios from "axios"
import apiBaseUrl from "./apiBase"

const REQUEST_TIMEOUT_MS = 30000;

const profileApi = {
  getLogin: (loginDetails) => {
    return axios.post(`${apiBaseUrl}/auth/signin`, loginDetails, { timeout: REQUEST_TIMEOUT_MS })
  },
  userSignUp: (signUpDetails) => {
    return axios.post(`${apiBaseUrl}/auth/signup`, signUpDetails, { timeout: REQUEST_TIMEOUT_MS })
  },
  requestPasswordReset: (resetDetails) => {
    return axios.post(`${apiBaseUrl}/auth/forgot-password`, resetDetails, { timeout: REQUEST_TIMEOUT_MS })
  },
  resetPassword: (resetDetails) => {
    return axios.post(`${apiBaseUrl}/auth/reset-password`, resetDetails, { timeout: REQUEST_TIMEOUT_MS })
  },
  contactUs: (contactDetails) => {
    return axios.post(`${apiBaseUrl}/contact`, contactDetails, { timeout: REQUEST_TIMEOUT_MS })
  }
}

export default profileApi
